import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';

import { IChatMessage } from '@app/features/chat/models/chat';
import {ITicket} from "@shared/models/ticket";

@Component({
  selector: 'tlm-message-list',
  templateUrl: './message-list.component.html',
  styleUrls: ['./message-list.component.scss']
})
export class MessageListComponent implements AfterViewInit{
  @Input() messages: Array<IChatMessage>;
  @Input() ticket: ITicket;
  @Input() userId: any;
  @Input() sendingStatus: any;
  @Output() setDelivery: EventEmitter<IChatMessage> = new EventEmitter();
  @Output() scrollBottom: EventEmitter<any> = new EventEmitter();
  lastDate: Date;

  setDelivey(event) {
    this.setDelivery.emit(event);
  }

  showDate(date: number, index: number) {

    if (index === 0) {
      this.lastDate = new Date(date);
      return true;
    }
    const current = new Date(date);
    const diff = current.getTime() - this.lastDate.getTime();
    const days = Math.round(diff / (1000 * 3600 * 24));
    this.lastDate = new Date(date);
    return (days > 0) ? true : false;
  }

  ngAfterViewInit() {
    this.scrollBottom.emit();
  }
}
